module.exports = __webpack_public_path__ + "img/okay-disabled.ea6b6fe9.svg";